import { create } from 'zustand'

const useUserStore = create(set => ({
  userId: null,
  setUserId: v => set({ userId: v }),

  userName: null,
  setUserName: v => set({ userName: v }),

  userPermissions: [],
  setUserPermissions: userPermissions => set({ userPermissions })
}))

export default useUserStore
